<template>
    <div class="login-wrapper-page">

        <div class="panel login-panel">
            <div class="login-panel-heading">
                <div class="login-logo"></div>
            </div>

            <div class="login-panel-body">
                <h5 class="text-muted text-center"><b> Please enter your account email address.</b></h5>
                <form class="form-horizontal">
                    <div class="col-xs-11">
                        <input placeholder="Email Address" type="text" v-model="emailAddress">
                    </div>

                    <div class="form-group text-center">
                        <div class="col-xs-12">
                            <ac-button class="btn-sm btn-blue" :action="resetPassword" style="margin-bottom: 10px; width:88%">
                                RESET PASSWORD
                            </ac-button>
                        </div>
                        <div class="col-xs-12">
                            <ac-button class="btn-sm btn-red" :action="cancel" style="width:88%">
                                CANCEL
                            </ac-button>
                        </div>
                    </div>
                    <div class="text-center text-muted col-xs-12">
                        If you do not have your email information, or do not receive an email from us to reset password, please email <a href="mailto: support@accresa.com" target="_blank">support@accresa.com</a>
                        for further assistance.
                    </div>
                </form>
                <div class="col-md-12">
                    <p><img class="center-block" src="../../../assets/images/hipaa-150.png"></p>
                </div>
            </div>
        </div> <!--close panel -->
    </div>
</template>

<script>
    import {common} from "../../../global/common.js";
    import {validators} from "../../../global/validators.js";
    import {notifications} from "../../../global/notifications.js";
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "PasswordReset",
        data: function () {
            return {
                emailAddress: ""
            }
        },
        methods: {
            async resetPassword() {
                if (validators.validateEmail(this.emailAddress)) {
                    await api.post('Account', 'ForgotPassword', {email: this.emailAddress});
                } else {
                    notifications.show({title: 'ERROR', message: 'Please enter a valid email address.'}, common.ACRESSA_NOTIFICATIONS.ERROR);
                }
            },
            cancel() {
                common.goBack();
            }
        }
    }
</script>

<style scoped>

</style>